import React from "react";
import Icon from "@ant-design/icons";

const EditSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path stroke="currentColor" strokeLinecap="round" d="M18 18H2"></path>
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M6.906 14.92L17.075 3.119 14.611 1 9.49 7.113 4.365 13v2.669l2.541-.75z"
    ></path>
  </svg>
);
const EditPencilSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M5.525 11.936l8.135-9.441L11.69.8 7.59 5.69 3.492 10.4v2.135l2.033-.6z"
    ></path>
  </svg>
);

const EditV3Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 13 13"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M4.558 10.42L11.543 2.316 9.433.5 5.927 4.71 2.402 8.749l.225 2.026z"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M12.5 12.441H6.979.5"
    ></path>
  </svg>
);


const EditIcon = (props) => {
  return <Icon component={EditSvg} {...props} />;
};
const EditPencilIcon = (props) => {
  return <Icon component={EditPencilSvg} {...props} />;
};
const EditV3Icon = ({ width, height, style, ...rest }) => {
  return (
    <Icon
      component={EditV3Svg}
      style={{ fontSize: width || height || 13, ...style }}
      {...rest}
    />
  );
};


export { EditIcon, EditPencilIcon, EditV3Icon };